<template>
  <v-container>
    <div>
      <v-row justify="space-between">
        <v-col cols="12" sm="6" justify="center">
          <p class="header-title"> {{$t('menu.competitor_list')}} </p>
        </v-col>

        <v-col cols="12" sm="6" justify="center" class="pr-5">
          <v-row class="d-flex justify-end">
            <v-dialog v-model="dialog" persistent max-width="60%">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">{{ $t('competitor.add')}}</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                  <v-container>
                    <v-row no-gutters class="mt-5">
                      <v-col cols="12">
                        <v-text-field v-model="editedItem.name" :rules="stringRules" v-bind:label="$t('competitor.name')" outlined></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <v-textarea v-model="editedItem.description" v-bind:label="$t('competitor.description')" outlined></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-btn color="primary" class="ml-5" dark @click="close" width="120px">{{ $t('common.cancel')}}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="mr-5" dark @click="save" width="120px">{{ $t('common.save')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="email" :loading="loading" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
      <template v-slot:top >
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined dense></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
            </v-col>

            <v-col cols="12" sm="2">
            </v-col>

            <v-col cols="12" sm="7">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-icon  small class="mr-2"  @click="editItem(item)">
          edit
        </v-icon>
        <v-icon  small @click="deleteItem(item)">
          delete
        </v-icon>

      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  data: () => ({
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,

    numberPage: [
      5, 10, 15, 20, 25
    ],

    search: '',
    dialog: false,
    loading: true,
    headers: [
      { text: '#', align: 'left', sortable: false, value: 'index' },
      { text: i18n.t('competitor.name'), value: 'name' },
      { text: i18n.t('competitor.description'), value: 'description' },
      { text: '', value: 'action', sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
    },
    defaultItem: {
    },
    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      // v => (v && v.length > 5) || i18n.t('validate.string_invalid')
    ],
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? i18n.t('competitor.add') : i18n.t('competitor.edit')
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  created () {
    this.getData();
  },

  methods: {
    initialize () {
    },

    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    async deleteItem (item) {
      const agree = confirm(i18n.t('common.confirm_delete'))

      if (agree) {
        const response =  await this.$http.delete(process.env.VUE_APP_COMPETITOR_API + item._id);
        if(response.data && response.data.success) {
          this.desserts.splice(item.index - 1, 1);
          this.desserts.forEach((item, index) =>item.index = index + 1);
        } else if(response.data && !response.data.success) {
          alert(i18n.t(response.data.message));
        } else {
          alert(i18n.t('validate.request_error'));
        }
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save () {
      const self = this;

      if (!this.editedItem.name || this.editedItem.name.length == 0) {
        alert(i18n.t('validate.infor_empty'));
        return;
      }

      if (this.editedIndex > -1) {
        try {
          const requestBody =  self.editedItem;

          console.log(requestBody);
          const response = await this.$http.put(process.env.VUE_APP_COMPETITOR_API + self.editedItem._id,  requestBody);

          if (response.data && response.data.success) {
            Object.assign(this.desserts[this.editedIndex], this.editedItem);
            self.editedItem = {};
          } else if(response.data && !response.data.success) {
            alert(i18n.t(response.data.message));
          } else {
            alert(i18n.t('validate.request_error'));
          }
        } catch (e) {
          console.log(e.stack);
          alert(i18n.t('validate.request_error'));
        }
      } else {
        try {
          const requestBody = self.editedItem;
          const response = await this.$http.post(process.env.VUE_APP_COMPETITOR_API, requestBody);

          if (response.data && response.data.success) {
            self.editedItem._id = response.data.data.id;

            this.desserts.push(self.editedItem);
            self.editedItem.index = this.desserts.length;
            self.editedItem = {};

            this.$fire({
              title: i18n.t('common.success'),
              text: "",
              type: "success"
            }).then(() => {

            });
          } else if(response.data && !response.data.success) {
            alert(i18n.t(response.data.message));
          } else {
            alert(i18n.t('validate.request_error'));
          }
        } catch (e) {
          console.log(e.stack);
          alert(i18n.t('validate.request_error'));
        }
      }
      this.close()
    },

    async getData() {
      try {
        const response = await this.$http.get(process.env.VUE_APP_COMPETITOR_API);
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          contextArr.forEach((item, index) =>item.index = index + 1);

          this.desserts = contextArr;

          this.loading = false;
        }
      } catch (e) {
        console.log(e.stack);
      }
    }
  },
}
</script>